import {
  SlTree
} from "./chunk.AZ343NTV.js";

// src/components/tree/tree.ts
var tree_default = SlTree;
SlTree.define("sl-tree");

export {
  tree_default
};
